/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {HighlightLegend} from './highlight-legend';

export class HighlightDate {
  public date: Date;
  public type: HighlightLegend;

  /**
   * Build the HighlightDate with required date and color object.
   * Apply style on the date if is defined, else apply hexa (hexadecimal specific color) (ex: #FFF).
   * if style is undefined and hexa is undefined, apply default style to the cell.
   * text color apply a specific color to the highlight day. Default value : #FFF
   * @param date
   * @param type
   */
  constructor(date: Date, type: HighlightLegend) {
    this.date = date;
    this.type = type;
  }
}
